<template>
  <div class="problem-edit">
    <header>
      <button class="btn-img med btn-cancel" @click="cancel" title="Cancel"></button>
      <button v-if="!editing && ['ViewAdmin','Reporter'].indexOf(profile.role) === -1" class="btn med secondary" @click="startEdit">Edit</button>
    </header>
    <div :class="{ wrapper: true, selectedImage:selectedImage }">
      <div class="contents">
        <div v-if="fields">
          <template v-for="(fieldName, index) in fieldBlocks">
            <template v-if="fieldName === 'status'">
              <div v-bind:key="index">
                <div class="row" v-if="fullEditing || (!fullEditing && problem['roomName'])" >
                  <h4>Room Name</h4>
                  <input v-if="fullEditing" v-model="problem['roomName']" placeholder="eg: Music room" type="text" />
                  <div class="print-data" v-else>{{ problem['roomName'] }}</div>
                </div>
                <div class="row" v-if="fullEditing || (!fullEditing && problem['roomNumber'])" >
                  <h4>Room Number</h4>
                  <input v-if="fullEditing" v-model="problem['roomNumber']" placeholder="eg: Music room" type="text" />
                  <div class="print-data" v-else>{{ problem['roomNumber'] }}</div>
                </div>
                <div class="row" v-if="fullEditing || (!fullEditing && problem['description'])">
                  <h4>Description</h4>
                  <textarea v-if="fullEditing" v-model="problem['description']" placeholder="Describe the problem"></textarea>
                  <div class="print-data" v-else>{{ problem['description'] }}</div>
                </div>
                <div v-if="fields && problem.status.value > -2 && ['ViewAdmin'].indexOf(profile.role) === -1 && !create" class="row additionalStatus">
                  <h4>New Status</h4>
                  <div>
                    <div class="stat">
                      <v-select :options="statusValuesForNewStatus" label="shortLabel" v-model="newStatusSelect" @input="newStatusSelected" placeholder="Select a status"></v-select>
                      <div class="status-print">
                        <div class="byline">
                          <em>by {{ newStatus.creatorName }}</em>, <em>{{ statusDate(newStatus) }}</em>
                        </div>
                        <div class="byline" v-if="['Admin'].indexOf(profile.role) === 0">
                          <input type="text" v-model="newStatus.creatorOrganization" placeholder="Organization"/>
                        </div>
                        <textarea v-model="newStatus.comment" placeholder="Write a comment..."></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row" v-if="editing"> -->
                <div class="row">
                  <div></div>
                  <div v-if="['ViewAdmin'].indexOf(profile.role) === -1 && !create">
                    <button class="btn sml creation" @click="addStatus">Add Status</button>
                  </div>
                </div>
              </div>
            </template>
            <div class="row" v-bind:key="fieldName" v-if="!(fieldName === 'status' && create)">
              <h4>{{ fields[fieldName].mediumLabel }}</h4>
              <div style="margin-bottom: -11px" >
                <v-select v-if="fullEditing || (fieldName === 'status' && editing && problem.status.creatorUserId === currentUserId)" :options="fields[fieldName].values" label="shortLabel" v-model="problem[fieldName]" @input="fieldChanged(fieldName)"></v-select>
                <!-- <v-select v-if="fullEditing" :options="fields[fieldName].values" label="shortLabel" v-model="problem[fieldName]" @input="fieldChanged(fieldName)"></v-select> -->
                <div class="print-data" v-else>
                  <span v-if="fieldName !== 'status'">
                    {{ problem[fieldName].shortLabel }}
                  </span>
                  <span v-else-if="!create">
                    <strong>{{ problem[fieldName].shortLabel }}</strong>
                  </span>
                  <span v-if="fieldName === 'status'">
                    <em v-if="!fullEditing || (editing && problem.status.creatorUserId === currentUserId)"> {{ statusDate(problem.status) }}</em>
                  </span>
                </div>
                <div v-if="fieldName === 'status'" class="status-print">
                  <div class="byline" v-if="fullEditing || (editing && problem.status.creatorUserId === currentUserId)">
                    <div class="byline">
                      <em v-if="['Admin','ViewAdmin'].indexOf(profile.role) > -1">by {{ problem.status.creatorName }} </em>
                      <em> {{ statusDate(problem.status) }}</em>
                    </div>
                    <div class="byline">
                      <date-pick
                          v-bind:value="problem.status.lastModifiedDate"
                          v-on:input="statusChanged(problem.status, $event)"
                          :format="'MMM D YY h:mm a'"
                          :pickTime="true"
                          :parseDate="parseDate"
                          :isDateDisabled="isFutureDate"
                          :formatDate="formatDate"
                      ></date-pick>
                    </div>
                    <div class="field">
                      <input type="text" v-model="problem.status.creatorOrganization" placeholder="Organization" v-on:change="statusFieldChanged()"/>
                    </div>
                  </div>
                  <div class="byline view" v-else>
                    <p v-if="['Admin','ViewAdmin'].indexOf(profile.role) > -1 && problem.status.creatorUserId"><em>by {{ status.lastModifiedAppOS }} {{ status.lastModifiedAppVersion }} {{ problem.status.creatorName && problem.status.creatorName !== '' > 0 ? problem.status.creatorName : problem.status.creatorUserId }} <a v-if="problem.status.creatorEmail" class="mail" :href="'mailto:' + problem.status.creatorEmail">📧</a></em></p>
                    <em><span v-if="problem.status.creatorRole">{{ problem.status.creatorRole }} @ </span>{{ problem.status.creatorOrganization }}</em>
                  </div>
                  <div class="byline" v-if="fullEditing || (editing && problem.status.creatorUserId === currentUserId)">
                    <textarea v-model="problem.status.comment" placeholder="Write a comment..." v-on:change="statusFieldChanged()"></textarea>
                  </div>
                  <div v-else-if="problem.status.comment" class="status-description">
                    <p>{{ problem.status.comment }}</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="status-history row" v-if="problem.statusHistory.length > 0">
          <h4> </h4>
          <div class="historyCol" v-if="fields != null">
            <div class="historyItem" v-for="(status, index) in problem.statusHistory" v-bind:key="status['.lastModified']">
              <div v-if="fullEditing || (editing && status.creatorUserId === currentUserId)" class="statusField">
                <div>
                  <strong>{{ status.shortLabel }} </strong>
                </div>
                <button class="btn sml" v-on:click="deleteStatusHistoryAt(index)">Delete</button>
              </div>
              <div class="print-data" v-else>
                <strong>{{ status.shortLabel }} </strong>
                  <em>{{ statusDate(status) }}</em>
              </div>
              <div class="status-print">
                <div class="byline" v-if="fullEditing || (editing && status.creatorUserId === currentUserId)">
                  <div class="byline">
                    <em v-if="['Admin','ViewAdmin'].indexOf(profile.role) > -1">by {{ status.creatorName }} </em>
                    <em> {{ statusDate(status) }}</em>
                  </div>
                  <div class="byline">
                    <date-pick
                        v-bind:value="status.lastModifiedDate"
                        v-on:input="statusChanged(status, $event)"
                        :format="'MMM D YY h:mm a'"
                        :pickTime="true"
                        :parseDate="parseDate"
                        :isDateDisabled="isFutureDate"
                        :formatDate="formatDate"
                    ></date-pick>
                  </div>
                  <div class="field">
                    <input type="text" v-model="status.creatorOrganization" placeholder="Organization"/>
                  </div>
                </div>
                <div class="byline" v-else>
                  <p v-if="['Admin','ViewAdmin'].indexOf(profile.role) > -1 && status.creatorUserId"><em>by {{ status.lastModifiedAppOS }} {{ status.lastModifiedAppVersion }} {{ status.creatorName && status.creatorName !== '' > 0 ? status.creatorName : status.creatorUserId }} <a v-if="status.creatorEmail" class="mail" :href="'mailto:' + status.creatorEmail">📧</a></em></p>
                  <em>{{ status.creatorOrganization }}</em>
                </div>
                <div v-if="fullEditing || (editing && status.creatorUserId === currentUserId)">
                  <textarea v-model="status.comment" placeholder="Write a comment..."></textarea>
                </div>
                <div v-else-if="status.comment" class="status-description">
                  <p>{{ status.comment }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <h4>Images</h4>
          <div>
            <div id="existing-images">
              <span class="prob-img" v-bind:key="image['.metadata.name']" v-for="image in problem.images.filter(img => img.downloadUrl)">
                <img v-bind:key="image['.metadata.name']" :src="image.downloadUrl" @click.stop="selectedImage = image" />
                <!-- <input type="button" value="delete" @click="removeImage(image)"/> -->
                <button v-if="fullEditing" @click="removeImage(image)" class="btn-img btn-minus"></button>
              </span>
            </div>
            <div v-if="addingImages" id="new-images">
              <input type="file" ref="fileInput" accept="image/*" value="Choose Images" @change="onFilesPicked" multiple/>
              <div>
                <span class="prob-img" v-for="image in problem.images.filter(img => img.dataUrl)" v-bind:key="image['.metadata.name']">
                  <img v-bind:key="image['.metadata.name']" :src="image.dataUrl" />
                  <button @click="removeNewImage(image)" class="btn-img btn-minus"></button>
                </span>
              </div>
            </div>
            <div v-else-if="editing">
              <button class="btn sml creation" @click="addingImages = true">Add Image</button>
            </div>
          </div>
        </div>
        <div class="row" v-if="editing">
          <div></div>
          <div class="sbmt-row">
            <button :class="{'btn': true, 'inactive': !edited, 'creation': edited}" @click="save">Save</button>
            <button class="btn tertiary" @click="cancelEdit">Cancel</button>
          </div>
        </div>
      </div>
      <div class="image">
        <div class="inner">
          <span class="back" @click="selectedImage = null">&lsaquo; Back</span>
          <img v-if="selectedImage" :src="selectedImage.downloadUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import database from '@/api/database.js'
  import DatePick from 'vue-date-pick'
  import { distanceInWordsStrict, parse, format, differenceInDays } from 'date-fns'
  export default {
    name: 'ProblemEditor',
    components: {
      vSelect, DatePick
    },
    props: {
      problem: {
        type: Object,
        default: function () { return database.assembleProblem() }
      },
      fulledit: {
        type: Boolean,
        default: false
      },
      edit: {
        type: Boolean,
        default: false
      },
      create: {
        type: Boolean,
        default: false
      },
      profile: {
        type: Object
      }
    },
    data() {
      return {
        edited: false,
        fields: null,
        addingImages: false,
        newStatus: {},
        newStatusSelect: {shortLabel: 'Select a status'},
        currentStatusSelect: {shortLabel: 'Select a status'},
        editing: this.edit,
        status: {},
        numNewImages: 0,
        currentUserId: '',
        selectedImage: null
      }
    },
    mounted () {
      database.getFields().then(fields => {
        this.fields = fields
        if (this.profile.role === 'Reporter') {
          this.statusValuesForNewStatus = this.fields.status.values.filter(status => ['9','15','16'].indexOf(status.value) > -1)
        } else {
          this.statusValuesForNewStatus = this.fields.status.values
        }
      }),
      this.newStatus = database.assembleStatus()
      this.status = JSON.parse(JSON.stringify(this.problem.status))
      if ('Admin'.indexOf(this.profile.role) > -1) {
        this.edited = true
      }
      database.getCurrentUserAndProfile().then(uap => {
        this.currentUserId = uap.user.uid
      })
    },
    computed : {
      fullEditing () {
        // console.log('editing', this.editing)
        // console.log('fulledit', this.fulledit)
        // console.log('role', this.profile.role)

        return this.editing && this.fulledit && this.profile.role !== 'ViewAdmin'
      },
      fieldBlocks () {
        var blocks = ['school','floorType','roomType','problemType','priority','role','status']
        if (this.profile.role === 'Reporter') {
          blocks = ['school','floorType','roomType','problemType','status']
        }
        return blocks
      } 
    },
    methods: {
      fieldChanging (fieldName) {
        console.log('before changing status', this.problem.status)
        if (fieldName === 'status') {
          this.status = this.problem.status
        }
      },
      statusFieldChanged () {
        // console.log('changed!')
        if (this.status.creatorOrganization !== this.problem.status.creatorOrganization ||
            this.status.comment !== this.problem.status.comment ||
            this.status.lastModified !== this.problem.status.lastModified ||
            this.status.value !== this.problem.status.value) {
          // console.log('edited!!')
          this.edited = true
        }
      },
      fieldChanged (fieldName) {
        // try to prevent this from executing if the the current status was modified via "Add Status"
        // console.log('%s status last modified %s problem.status.last %s', fieldName, this.status.lastModified,this.problem.status.lastModified)
        this.edited = this.status.value !== this.problem.status.value
        // need to clone the fields on a status change because of the way we setup the v-model ... only clone if the value changes
        if (fieldName === 'status' && this.status.value !== this.problem.status.value) {
          this.problem.status.creatorUserId = this.status.creatorUserId
          this.problem.status.creatorName = this.status.creatorName
          this.problem.status.creatorOrganization = this.status.creatorOrganization
          this.problem.status.creatorEmail = this.status.creatorEmail
          this.problem.status.creatorIpAddress = this.status.creatorIpAddress
          this.problem.status.comment = this.status.comment
          this.problem.status.lastModified = this.status.lastModified
          this.problem.status.lastModifiedDate = this.status.lastModifiedDate            
        } else if (fieldName === 'status' && (this.status.creatorOrganization !== this.problem.status.creatorOrganization || 
                                       this.status.comment !== this.problem.status.comment || 
                                       this.status.lastModified !== this.problem.status.lastModified)) 
        {
          this.status.lastModified = this.problem.status.lastModified
          this.status.lastModifiedDate = this.problem.status.lastModifiedDate
          this.status.creatorOrganization = this.problem.status.creatorOrganization
          this.status.comment = this.problem.status.comment
        }
      },
      parseDate (dateString, formatString) {
        return parse(dateString)
      },
      formatDate (dateObj, formatString) {
        return format(dateObj, formatString)
      },
      isFutureDate(date) {
        const currentDate = new Date()
        return date > currentDate
      },
      statusChanged (status, newDate) {
        const dateTime = parse(newDate)
        // console.log(dateTime)
        status.lastModifiedDate = format(dateTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
        status.lastModified = dateTime.getTime()
        this.edited = true
      },
      statusTime (status) {
        const created = parse(status.lastModified)
        var time = format(created, 'MMM D, YYYY h:mm a')
        return time
      },
      statusDate (status) {
        const created = parse(status.lastModified)
        const daysAgo = differenceInDays(created, new Date())
        // console.log(daysAgo)
        var time = format(created, daysAgo < -7 ? 'MMM D h:mm a' : 'h:mm a')
        const now = new Date()
        var words = distanceInWordsStrict(created, now)
        return words + ' ago at ' + time
      },
      newStatusSelected () {
        this.newStatus.value = this.newStatusSelect.value
        this.newStatus.shortLabel = this.newStatusSelect.shortLabel
      },
      addStatus (event) {
        if (this.newStatus.value > -2) {
          database.addStatus(this.problem, this.newStatus).then(updatedProblem => {
            this.newStatus = database.assembleStatus()
            this.newStatusSelect = {shortLabel: 'Select a status'}
          })
        }
      },
      onFilesPicked (event) {
        Object.values(event.target.files).forEach(file => {
          let image = database.assembleImage(file)
          console.log(image)
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            image.dataUrl = fileReader.result
            this.problem.images.push(image)
          })
          fileReader.readAsDataURL(file)
          this.numNewImages++
          this.edited = true
        })
        event.srcElement.value = ''
      },
      save (event) {
        if (this.problem.id) {
          database.updateProblem(this.problem).then(saved => {
            this.$emit('updated', saved)
          })
        } else {
          // this.problem.creatorUserId = this.user.uid
          database.createProblem(this.problem).then(saved => {
            this.$emit('created', saved)
          })
        }
        // this.problem = database.assembleProblem()
      },
      cancel () {
        this.editing = false
        this.$emit('cancel')
      },
      deleteStatusHistoryAt (index) {
        this.edited = true
        this.problem.statusHistory.splice(index, 1)
      },
      removeImage (removedImage) {
        const minusRemovedImage = this.problem.images.filter(img => img.storageName !== removedImage.storageName)
        this.problem.images = minusRemovedImage
        this.edited = true
      },
      removeNewImage (removedImage) {
        const minusRemovedImage = this.problem.images.filter(img => img.storageName !== removedImage.storageName)
        this.problem.images = minusRemovedImage
        this.numNewImages--
        this.edited = this.numNewImages > 0
      },
      startEdit () {
        this.editing = true
      },
      cancelEdit () {
        this.editing = false
      }
    }
  }
</script>
<style>
  .vdpComponent.vdpWithInput>input {
    border-radius: 3px;
    border:1px solid rgba(60,60,60,.26);
    font-size: small;
    padding: 4px 30px 4px 8px;
    font-family: inherit;
    line-height: 1.42857143;
    color: #333;
  }
</style>

<style scoped>
  .wrapper {
    position: relative;
    overflow: hidden;
  }
  .wrapper .image,
  .wrapper .contents {
    transition: all ease 0.5s;
  }
  .wrapper.selectedImage .contents,
  .wrapper.selectedImage .image {
    transform: translateX(-100%);
  }
  .wrapper .image {
    position: absolute;
    top: 0;
    left: 100%;
    width: 100%;
    
  }
  .wrapper .image .back:hover {
    background: #bbb;
  }
  .wrapper .image .back {
    display: inline-block;
    font-weight: bold;
    padding: 8px 10px;
    margin-bottom: 1rem;
    cursor: pointer;
    border-radius: 3px;
    transition: all ease 0.2s;
  }
  .wrapper .image img {
    max-width:100%; 
  }
  em {
    color: rgb(123, 143, 155);
    font-style: normal;
  }
  .problem-edit {
    padding: 20px;
  }
  header {
    height: 40px;
  }
  header * {
    float: right;
    margin-left: 10px;
  }
  h4 {
    margin: 0 0 5px;
    vertical-align:middle;
    color: #555;
  }
  .row {
    margin-bottom: 1.5rem;
  }
  @media only screen and (min-width: 680px) {    
    h4 {
      text-align: right;
      margin-bottom: 0;
    }
    .row {
      display: grid;
      grid-template-columns: 30% 67%;
      grid-template-rows: auto;
      grid-row-gap: 13px;
      grid-column-gap: 3%;
      vertical-align:middle;
    }
  }
  .row h4 {
    margin-top: 6px;
  }
  input[type=text], textarea {
    border-radius: 3px;
    border:1px solid rgba(60,60,60,.26);
    font-size: small;
    padding: 4px 8px;
    font-family: inherit;
    line-height: 1.42857143;
    color: #333;
  }
  textarea {
    width: 60%;
  }
  .row img {
    height: 55px;
    animation: fadein 3s;
  }
  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  #existing-images {
    margin-bottom: 10px;
  }
  #new-images div {
    padding: 15px 0 0;
  }
  .prob-img {
    position: relative;
    display: inline-block;
    border: 2px solid #bbb;
    margin-right: 10px
  }
  .prob-img img {
    display: inline-block;
    vertical-align: bottom;
  }
  .prob-img .btn-minus {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 14px;
    height: 14px;
    box-shadow: 0 0 0px 3px hsla(255, 0%, 100%, 1);
  }
  .prob-img .btn-minus::after {
    width: 16px;
    height: 16px;
  }
  .sbmt-row {
    border-top: 2px solid #bbb;
    padding-top:20px;
    display: flex;
  }
  .sbmt-row .btn {
    margin-right: 10px;
  }
  .sbmt-row .btn-img.btn-cancel {
    width: 34px;
    height: 34px;
  }
  .sbmt-row .btn-img.btn-cancel::after {
    width: 30px;
    height: 30px;
    top:2px;
    left:2px;
  }
  .status-history .historyItem {
    padding-bottom: 5px;
    border-bottom: 1px solid #bbb;
    padding-top: 10px;
  }
  .status-history .historyItem  .print-data {
    font-size: 0.80rem;
    padding-top: 0;
  }
  .historyCol {
    border-top: 1px solid #bbb;
  }
  .status-print {
    padding: 6px 0 0 0;
  }
  .status {
    display: grid;
    grid-template-columns: 48% 48%;
    grid-template-rows: auto;
    grid-row-gap: 13px;
    grid-column-gap: 4%;
    padding-top: 10px;
  }
  .status input {
    display: flex;
  }
  .status div {
    display: grid;
    grid-template-columns: 100%;
  }
  .status-print h5 {
    margin: 5px 0 2px;
    color: #555;
  }
  .status-print .nocomment {
    font-size: 0.7rem;
    margin: 5px 0 2px;
  }
  .status-print p {
    margin: 0 0 5px;
  }
  .status-print textarea {
    margin-top: 0px;
  }
  .status h5 {
    margin: 0 0 3px;
  }
  .statusField {
    display: grid;
    grid-template-columns: auto 58px;
    grid-column-gap: 4%;
  }
  .field {
    display: flex;
  }
  .field h5 {
    display: flex;
    margin-right: 10px;
  }
  .byline {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 680px) {    
  .print-data {
    padding-top: 6px;
  }
  }
  img.userprofile {
    margin-left: 8px;
    height: 36px;
    width: 36px;
    clip-path: circle(18px at center);
  }
  .btn-calendar {
    margin-left: 4px;
    margin-top: 2px
  }
  .status-description {
    display: block;
    background-color: hsla(0, 0%, 95%, 1);
    padding: 5px 5px 1px;
  }
  .mail {
    font-size: 1.25rem;
    vertical-align: bottom;
    position: relative;
    top: 6px;
    text-decoration: none;
  }
</style>